import type { AppModule } from '@modules/core/plugins/AppModule';
import { AdminFeesSettingsModule } from '@modules/admin-fees/AdminFeesSettingsModule';
import { AffBalancesModule } from '@modules/aff-balances/AffBalancesModule';
import { AffiliateApiModule } from '@modules/affiliate-api/AffiliateApiModule';
import { AffiliateBannerViewModule } from '@modules/affiliate-banner-view/AffiliateBannerViewModule';
import { AffiliateProgramCommissionsModule } from '@modules/affiliate-program-commissions/AffiliateProgramCommissionsModule';
import { AffiliateProgramCreativesModule } from '@modules/affiliate-program-creatives/AffiliateProgramCreativesModule';
import { AffiliateProgramPromoCodesModule } from '@modules/affiliate-program-promo-codes/AffiliateProgramPromoCodesModule';
import { AffiliateProgramSubaffiliateDealsModule } from '@modules/affiliate-program-subaffiliate-deals/AffiliateProgramSubaffiliateDealsModule';
import { AffiliateProgramTrackersModule } from '@modules/affiliate-program-trackers/AffiliateProgramTrackersModule';
import { AffiliateReferenceModule } from '@modules/affiliate-reference/AffiliateReferenceModule';
import { AffiliateTrackersModule } from '@modules/affiliate-trackers/AffiliateTrackersModule';
import { AffiliatesApprovedModule } from '@modules/affiliates-approved/AffiliatesApprovedModule';
import { AffiliatesPendingModule } from '@modules/affiliates-pending/AffiliatesPendingModule';
import { AffiliatesProfileModule } from '@modules/affiliates-profile/AffiliatesProfileModule';
import { AffiliatesRequestHistoryModule } from '@modules/affiliates-request-history/AffiliatesRequestHistoryModule';
import { AffiliatesUnconfirmedModule } from '@modules/affiliates-unconfirmed/AffiliatesUnconfirmedModule';
import { AnonymousMainModule } from '@modules/anonymous-main/AnonymousMainModule';
import { ArticlesModule } from '@modules/articles/ArticlesModule';
import { AdminAvailablePaymentSystemsModule } from '@modules/available-payment-systems/AdminAvailablePaymentSystemsModule';
import { BalanceCorrectionsModule } from '@modules/balance-corrections/BalanceCorrectionsModule';
import { BalancesModule } from '@modules/balances/BalancesModule';
import { BulkEmailsModule } from '@modules/bulk-emails/BulkEmailsModule';
import { ChangeHistoryModule } from '@modules/change-history/ChangeHistoryModule';
import { CreativesLinkModule } from '@modules/creatives-link/CreativesLinkModule';
import { DashboardModule } from '@modules/dashboard/DashboardModule';
import { DownloadReportModule } from '@modules/download-report/DownloadReportModule';
import { EmployeesModule } from '@modules/employees/EmployeesModule';
import { ExportDataModule } from '@modules/export-data/ExportDataModule';
import { FinanceModule } from '@modules/finance/FinanceModule';
import { ForgotPasswordModule } from '@modules/forgot-password/ForgotPasswordModule';
import { FormsModule } from '@modules/forms/FormsModule';
import { AdminGeneralSettingsModule } from '@modules/general-settings/AdminGeneralSettingsModule';
import { GroupsOfAdminsModule } from '@modules/groups-of-admins/GroupsOfAdminsModule';
import { GroupsOfManagersModule } from '@modules/groups-of-managers/GroupsOfManagersModule';
import { HeaderModule } from '@modules/header/HeaderModule';
import { I18nModule } from '@modules/i18n/I18nModule';
import { ImportedDataModule } from '@modules/imported-data/ImportedDataModule';
import { LoginModule } from '@modules/login/LoginModule';
import { MassRetagModule } from '@modules/mass-retag/MassRetagModule';
import { MerchantSettingsModule } from '@modules/merchant-settings/MerchantSettingsModule';
import { MirrorsListModule } from '@modules/mirrors-list/MirrorsListModule';
import { NewAppVersionModule } from '@modules/new-app-version/NewAppVersionModule';
import { PaymentSystemDetailsModule } from '@modules/payment-system-details/PaymentSystemDetailsModule';
import { PaymentSystemsModule } from '@modules/payment-systems/PaymentSystemsModule';
import { PendingWithdrawalsModule } from '@modules/pending-withdrawals/PendingWithdrawalsModule';
import { PlayersBonusesModule } from '@modules/players-bonuses/PlayersBonusesModule';
import { PlayersModule } from '@modules/players/PlayersModule';
import { PostbacksModule } from '@modules/postbacks/PostbacksModule';
import { ProfileSettingsModule } from '@modules/profile-settings/ProfileSettingsModule';
import { QuintsApiModule } from '@modules/quints-api/QuintsApiModule';
import { RegistrationModule } from '@modules/registration/RegistrationModule';
import { ReportsModule } from '@modules/reports/ReportsModule';
import { RolesAndPermissionsModule } from '@modules/roles-and-permissions/RolesAndPermissionsModule';
import { SidebarModule } from '@modules/sidebar/SidebarModule';
import { SmartFiltersModule } from '@modules/smart-filters/SmartFiltersModule';
import { StaticPagesModule } from '@modules/static-pages/StaticPagesModule';
import { TablesModule } from '@modules/tables/TablesModule';
import { TranslateManagerModule } from '@modules/translate-manager/TranslateManagerModule';
import { UnsubscribeModule } from '@modules/unsubscribe/UnsubscribeModule';
import { WebhooksHistoryModule } from '@modules/webhooks-history/WebhooksHistoryModule';
import { WelcomePageRedirectsModule } from '@modules/welcome-page-redirects/WelcomePageRedirectsModule';
import { WellKnownLinksModule } from '@modules/well-known-links/WellKnownLinksModule';
import { WithdrawalsHistoryModule } from '@modules/withdrawals-history/WithdrawalsHistoryModule';

export default function getAppModules(): AppModule[] {
  return [
    new SidebarModule(),
    new TablesModule(),
    new SmartFiltersModule(),
    new FormsModule(),
    new I18nModule(),
    new ReportsModule(),
    new ChangeHistoryModule(),
    new DashboardModule(),
    new TranslateManagerModule(),
    new LoginModule(),
    new RegistrationModule(),
    new AnonymousMainModule(),
    new UnsubscribeModule(),
    new PlayersModule(),
    new PlayersBonusesModule(),
    new AffiliatesApprovedModule(),
    new DownloadReportModule(),
    new AdminGeneralSettingsModule(),
    new RolesAndPermissionsModule(),
    new AffiliateProgramTrackersModule(),
    new AffiliateProgramPromoCodesModule(),
    new AffiliateProgramSubaffiliateDealsModule(),
    new AffiliateProgramCommissionsModule(),
    new MassRetagModule(),
    new FinanceModule(),
    new AffiliateProgramCreativesModule(),
    new GroupsOfAdminsModule(),
    new EmployeesModule(),
    new ArticlesModule(),
    new StaticPagesModule(),
    new ExportDataModule(),
    new ProfileSettingsModule(),
    new GroupsOfManagersModule(),
    new ImportedDataModule(),
    new AffiliatesRequestHistoryModule(),
    new QuintsApiModule(),
    new AffiliatesProfileModule(),
    new AffiliatesPendingModule(),
    new WebhooksHistoryModule(),
    new AffiliatesUnconfirmedModule(),
    new BalanceCorrectionsModule(),
    new WithdrawalsHistoryModule(),
    new CreativesLinkModule(),
    new PaymentSystemsModule(),
    new AffBalancesModule(),
    new PendingWithdrawalsModule(),
    new BalancesModule(),
    new HeaderModule(),
    new ForgotPasswordModule(),
    new BulkEmailsModule(),
    new PostbacksModule(),
    new AffiliateReferenceModule(),
    new AffiliateApiModule(),
    new MirrorsListModule(),
    new AffiliateTrackersModule(),
    new AffiliateBannerViewModule(),
    new NewAppVersionModule(),
    new MerchantSettingsModule(),
    new AdminFeesSettingsModule(),
    new PaymentSystemDetailsModule(),
    new AdminAvailablePaymentSystemsModule(),
    new WellKnownLinksModule(),
    new WelcomePageRedirectsModule(),
  ];
}
